import { render, staticRenderFns } from "./OSectionDashboardMenu.vue?vue&type=template&id=212b984a&"
import script from "./OSectionDashboardMenu.vue?vue&type=script&lang=js&"
export * from "./OSectionDashboardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports